import { HOW_STEPS } from '../data/content';
import './HowItWorks.css';

export default function HowItWorks() {
  return (
    <section id="how" className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Deployment process</span>
        <h2 className="sec-title">Live in weeks, not months.</h2>
        <p className="sec-sub">
          Our structured delivery process ensures your bot is trained on the right data,
          integrated with your systems, and deployed on your channels — with a clear timeline at every stage.
        </p>
        <div className="how__timeline">
          <div className="how__line" />
          {HOW_STEPS.map((step, i) => (
            <div key={step.num} className="how-step">
              <div className="how-step__num">{step.num}</div>
              <div className="how-step__body">
                <div className="how-step__header">
                  <h4 className="how-step__title">{step.title}</h4>
                  <span className="how-step__tag">{step.tag}</span>
                </div>
                <p className="how-step__desc">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
